@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";

:host {
  display: block;
}

.roles {
  &__container {
    display: grid;
    block-size: 100%;
    box-sizing: border-box;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-gap-l);
  }
  &__role {
    display: grid;
    grid-template-rows: auto 1fr;
    overflow: auto;
  }
  &__list {
    display: flex;
    flex-direction: column;
    block-size: 100%;
    overflow: auto;
  }
  &__list-header {
    display: grid;
    grid-template-rows: auto 1fr;
    gap: var(--spacing-gap-m);
  }
  &__list-title {
    background-color: var(--color-accent-surface-elevation-1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.add-remove-buttons {
  display: flex;
  justify-content: space-between;
}
